import { render } from "./OverlayModal.vue?vue&type=template&id=2930add1&scoped=true&ts=true"
import script from "./OverlayModal.vue?vue&type=script&lang=ts"
export * from "./OverlayModal.vue?vue&type=script&lang=ts"

import "./OverlayModal.vue?vue&type=style&index=0&id=2930add1&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution.Cashier/front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2930add1"]])

export default __exports__